import loadable from '@loadable/component';

export const EmbedSearchWidgetViewOrgPageLoadable = loadable(
  () => import('./EmbedSearchWidgetViewOrgPage'),
  { resolveComponent: (module) => module.EmbedSearchWidgetViewOrgPage },
);
